import { AuthRole } from "../../auth/types/AuthRole";
import { AdminViewType } from "./types/AdminViewType";

export const canAccessAdminView = (roles: AuthRole[]): boolean =>
  roles.includes(AuthRole.ADMIN) ||
  roles.includes(AuthRole.AUDITOR) ||
  roles.includes(AuthRole.SWPO_SUPPORT);

export const canAccessAdminViewType = (
  roles: AuthRole[],
  view: AdminViewType
): boolean => {
  if (roles.includes(AuthRole.ADMIN)) {
    return true;
  }

  const isAuditor = roles.includes(AuthRole.AUDITOR);
  const isSwpoSupport = roles.includes(AuthRole.SWPO_SUPPORT);

  if (isSwpoSupport) {
    return true;
  }

  if (isAuditor) {
    return (
      view !== AdminViewType.PROJECT_ANALYSIS &&
      view !== AdminViewType.UPDATE_SYNC
    )
  }

  return false;
};

export const getDefaultAdminView = (roles: AuthRole[]): AdminViewType =>
  canAccessAdminViewType(roles, AdminViewType.LICENSE_LOG)
    ? AdminViewType.LICENSE_LOG
    : AdminViewType.PROJECT_ANALYSIS;
